var _rect, _rect2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeaturedIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "#0A8BC7",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "#0A8BC7",
    fillOpacity: 0.1
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7929_24646",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 12,
    width: 24,
    height: 24
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 12,
    width: 24,
    height: 24,
    fill: "#0A8BC7"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7929_24646)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.2 32.5L31 29.7V32H32V28H28V29H30.3L27.5 31.8L28.2 32.5ZM17 33C16.45 33 15.9792 32.8042 15.5875 32.4125C15.1958 32.0208 15 31.55 15 31V17C15 16.45 15.1958 15.9792 15.5875 15.5875C15.9792 15.1958 16.45 15 17 15H31C31.55 15 32.0208 15.1958 32.4125 15.5875C32.8042 15.9792 33 16.45 33 17V23.7C32.6833 23.55 32.3583 23.4208 32.025 23.3125C31.6917 23.2042 31.35 23.125 31 23.075V17H17V31H23.05C23.1 31.3667 23.1792 31.7167 23.2875 32.05C23.3958 32.3833 23.525 32.7 23.675 33H17ZM17 31V17V23.075V23V31ZM19 29H23.075C23.125 28.65 23.2042 28.3083 23.3125 27.975C23.4208 27.6417 23.5417 27.3167 23.675 27H19V29ZM19 25H25.1C25.6333 24.5 26.2292 24.0833 26.8875 23.75C27.5458 23.4167 28.25 23.1917 29 23.075V23H19V25ZM19 21H29V19H19V21ZM30 35C28.6167 35 27.4375 34.5125 26.4625 33.5375C25.4875 32.5625 25 31.3833 25 30C25 28.6167 25.4875 27.4375 26.4625 26.4625C27.4375 25.4875 28.6167 25 30 25C31.3833 25 32.5625 25.4875 33.5375 26.4625C34.5125 27.4375 35 28.6167 35 30C35 31.3833 34.5125 32.5625 33.5375 33.5375C32.5625 34.5125 31.3833 35 30 35Z",
    fill: "#0A8BC7"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeaturedIcon);
export default __webpack_public_path__ + "static/media/featured_icon.c53731f7864324560922db9258493399.svg";
export { ForwardRef as ReactComponent };